import axios from 'axios';
import axiosUrl from './axios.service';
import authHeader from '../helpers/auth-header';
import store from '../store/index';
import AuthService from '../services/auth.service';
import router from '../router';
const API_URL = axiosUrl.getAxiosUrl();

class ImportsService {
    loadImports() {        
        return axios
            .get(API_URL + `/FilesOverview/fileImports`, {
                headers: authHeader(),
            })
            .then((response) => {
                store.commit('importItems/setImports', response.data);
                store.commit('importItems/togglePageLoadingStatus', false);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    loadStatuses() {
        return axios
            .get(API_URL + `/FilesOverview/fileImportStatuses`, {
                headers: authHeader(),
            })
            .then((response) => {
                store.commit('importItems/setImportStatuses', response.data);                
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    filterImports(status) {     
        return axios
            .get(API_URL + `/FilesOverview/fileImportsFiltered?fileStatus=${status}`, {
                headers: authHeader(),
            })
            .then((response) => {
                store.commit('importItems/setImports', response.data);
                store.commit('importItems/togglePageLoadingStatus', false);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    removeImportedFile(fileId) {
        store.commit('importItems/togglePageLoadingStatus', true);
        return axios
            .get(API_URL + `/FilesOverview/deleteImportedFile?fileId=${fileId}`, {
                headers: authHeader(),
            })
            .then((response) => {
                store.commit('importItems/setImports', response.data);
                store.commit('importItems/togglePageLoadingStatus', false);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

}

export default new ImportsService();
